/**
 * Empêche le téléchargement et la copie des images
 * À utiliser sur les événements onContextMenu et onDragStart
 */
export const preventImageProtection = (e) => {
  e.preventDefault();
  return false;
};

/**
 * Désactive le clic droit sur toutes les images du document
 * À appeler au montage du composant qui contient les images
 */
export const disableRightClickOnImages = () => {
  const handleContextMenu = (e) => {
    if (e.target.tagName === 'IMG') {
      e.preventDefault();
      return false;
    }
  };

  document.addEventListener('contextmenu', handleContextMenu);

  // Retourne une fonction de nettoyage
  return () => {
    document.removeEventListener('contextmenu', handleContextMenu);
  };
};

/**
 * Empêche le drag and drop des images
 */
export const preventImageDrag = () => {
  const handleDragStart = (e) => {
    if (e.target.tagName === 'IMG') {
      e.preventDefault();
      return false;
    }
  };

  document.addEventListener('dragstart', handleDragStart);

  return () => {
    document.removeEventListener('dragstart', handleDragStart);
  };
};

/**
 * Active toutes les protections d'images
 * Retourne une fonction pour désactiver toutes les protections
 */
export const enableImageProtection = () => {
  const cleanupRightClick = disableRightClickOnImages();
  const cleanupDrag = preventImageDrag();

  return () => {
    cleanupRightClick();
    cleanupDrag();
  };
};
